import { render, staticRenderFns } from "./ChequeRecuperacao.vue?vue&type=template&id=85dbdae0&scoped=true&"
import script from "./ChequeRecuperacao.vue?vue&type=script&lang=js&"
export * from "./ChequeRecuperacao.vue?vue&type=script&lang=js&"
import style0 from "./ChequeRecuperacao.vue?vue&type=style&index=0&id=85dbdae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85dbdae0",
  null
  
)

export default component.exports